import React, { useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { formViewSelector } from '@store/policies/schedule/selectors';
import { actOptions, policyAction } from '@store/policies/schedule/utils';
import { getEmails } from '@src/api/schedulePolicies';
import PolicyMultiSelect from './PolicyMultiSelect';
import DateTime from './DateTime';
import Notes from './Notes';
import ActivationRadio from './ActivationRadio';
import Email from './Email';
import { WarningOutlined } from '@ant-design/icons';

function useEmailList() {
  const [emailList, setEmailList] = useState([]);

  const fetchEmails = useCallback(async () => {
    const res = await getEmails();
    setEmailList(get(res, ['data', 'emailIds'], []));
  }, []);

  useEffect(() => {
    fetchEmails();
  }, [fetchEmails]);

  return emailList;
}

const activationContent = () => (
  <>
    <PolicyMultiSelect />
  </>
);

function Content({ type = policyAction.activate }) {
  const { activationState } = useSelector(formViewSelector);
  const emailList = useEmailList();

  return (
    <div>
      {type === policyAction.activate && activationContent()}
      <ActivationRadio type={type} />
      {activationState === actOptions.schedule && (
        <>
          <DateTime />
          {type === policyAction.reorder && (
            <div style={{ color: 'rgb(247, 170, 71)' }}>
              <WarningOutlined /> Please make sure not to add/remove any policy before this
              scheduled time as it will impact the sequence of policies.
            </div>
          )}
          <Email emailList={emailList} />
          <Notes />
        </>
      )}
    </div>
  );
}

export default React.memo(Content);
